// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  username: __t.string().primaryKey(),
  data: __t.string(),
  dayNumber: __t.u32().name("day_number"),
  money: __t.i64(),
  ratingAvg: __t.f32().name("rating_avg"),
  luxuryTier: __t.u32().name("luxury_tier"),
  updatedAt: __t.timestamp().name("updated_at"),
});
